import { render, staticRenderFns } from "./EmailChangeChild.vue?vue&type=template&id=7de6876a&lang=pug&"
import script from "./EmailChangeChild.vue?vue&type=script&lang=js&"
export * from "./EmailChangeChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports